<mat-card class="mb-1">
  <mat-card-header >
    <mat-card-title class="text-2xl font-semibold">{{ title() }}</mat-card-title>
  </mat-card-header>

  <mat-card-content>
    <form [formGroup]="employeeForm" (ngSubmit)="submit()">
      <!-- Client Selection Section -->
       <mat-stepper aria-label="Horizontal stepper" #stepper>
        <mat-step label="Client/Company Details" [hasError]="stepHasError('company')" errorMessage="Required fields missing">

          <div class="grid gap-4 pt-4">
            <mat-form-field appearance="outline" class="w-full">
              <mat-label>Client *</mat-label>
              <mat-select formControlName="clientId" (selectionChange)="onClientChanged()">
                <mat-option value="">Select client</mat-option>
                @for (item of clients(); track item.id) {
                  <mat-option [value]="item.id">{{ item.name }}</mat-option>
                }
              </mat-select>
              @if (employeeForm.controls.clientId.invalid && employeeForm.controls.clientId.touched) {
                <mat-error>Client is required.</mat-error>
              }
            </mat-form-field>
          </div>
        
          <!-- Company Information Section -->
          <div class="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
            <mat-form-field appearance="outline" class="w-full">
              <mat-label>Company *</mat-label>
              <mat-select formControlName="companyId" (selectionChange)="onCompanyChanged()">
                <mat-option value="">Select company</mat-option>
                @for (item of companies(); track item.id) {
                  <mat-option [value]="item.id">{{ item.name }}</mat-option>
                }
              </mat-select>
              @if (employeeForm.controls.companyId.invalid && employeeForm.controls.companyId.touched) {
                <mat-error>Company is required.</mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="outline" class="w-full">
              <mat-label>Unique Company Code *</mat-label>
              <mat-select formControlName="clientCompanyId">
                <mat-option value="">Select unique company code</mat-option>
                @for (item of clientCompanies(); track item.id) {
                  <mat-option [value]="item.id">{{ item.uniqueCompanyCode }} @if (item.companyClientCode) { ({{ item.companyClientCode }}) }</mat-option>
                }
              </mat-select>
              @if (employeeForm.controls.clientCompanyId.invalid && employeeForm.controls.clientCompanyId.touched) {
                <mat-error>Unique company code is required.</mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="outline" class="w-full">
              <mat-label>Employee Status *</mat-label>
              <mat-select formControlName="employeeStatusId">
                <mat-option value="">Select status</mat-option>
                @for (item of employeeStatuses(); track item.id) {
                  <mat-option [value]="item.id">{{ item.name }} ({{ item.code }})</mat-option>
                }
              </mat-select>
              @if (hasError('employeeStatusId', 'required')) {
                <mat-error>Status is required.</mat-error>
              }
            </mat-form-field>
          </div>
      <!-- Company Details Section -->
      <div class="grid gap-4 sm:grid-cols-2 lg:grid-cols-3 pt-4">
        <mat-form-field appearance="outline" class="w-full">
          <mat-label>Company Division</mat-label>
          <mat-select formControlName="companyDivisionId">
            <mat-option value="">Select division</mat-option>
            @for (item of companyDivisions(); track item.id) {
              <mat-option [value]="item.id">{{ item.name }}</mat-option>
            }
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-full">
          <mat-label>Company Job Title *</mat-label>
          <mat-select formControlName="companyJobTitleId">
            <mat-option value="">Select job title</mat-option>
            @for (item of companyJobTitles(); track item.id) {
              <mat-option [value]="item.id">{{ item.name }}</mat-option>
            }
          </mat-select>
          @if (hasError('companyJobTitleId', 'required')) {
            <mat-error>Job title is required.</mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-full">
          <mat-label>Classification *</mat-label>
          <input matInput formControlName="classification" placeholder="Enter classification">
          @if (hasError('classification', 'required')) {
            <mat-error>Classification is required.</mat-error>
          }
        </mat-form-field>

        <searchable-lookup-select
          formControlName="managerEmployeeId"
          label="Manager Employee"
          placeholder="Select manager"
          searchPlaceholder="Search employees"
          loadingLabel="Loading managers..."
          [options]="managerLookupResponses()"
          [loading]="managerLookupLoading()"
          (searchChanged)="onManagerLookupSearchChanged($event)" />

        <mat-form-field appearance="outline" class="w-full">
          <mat-label>Extract Date *</mat-label>
          <input matInput [matDatepicker]="extractDatePicker" formControlName="extractDate">
          <mat-datepicker-toggle matIconSuffix [for]="extractDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #extractDatePicker></mat-datepicker>
          @if (hasError('extractDate', 'required')) {
            <mat-error>Extract date is required.</mat-error>
          }
        </mat-form-field>
      </div>
      <!-- Organisational Levels Section -->
          <div class="p-4">
            <h3 class="mb-4 font-semibold">Organisational Levels</h3>
            <div class="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
              @for (i of [1, 2, 3, 4, 5, 6]; track i) {
                <mat-form-field appearance="outline" class="w-full">
                  <mat-label>Level {{ i }}</mat-label>
                  <mat-select [formControlName]="'currentLevel' + i + 'Id'">
                    <mat-option value="">Select level {{ i }}</mat-option>
                    @for (level of organisationalLevels(); track level.id) {
                      @if (level.level === i) {
                        <mat-option [value]="level.id">{{ level.name }}</mat-option>
                      }
                    }
                  </mat-select>
                  @if (i === 1 && hasError('currentLevel1Id', 'required')) {
                    <mat-error>Current level 1 is required.</mat-error>
                  }
                  @if (i === 2 && hasError('currentLevel2Id', 'required')) {
                    <mat-error>Current level 2 is required.</mat-error>
                  }
                </mat-form-field>
              }
            </div>
            @if (organisationalLevels().length === 0) {
              <p class="text-center text-sm">Select a company to view organisational levels</p>
            }
          </div>
      </mat-step>

      <!-- Personal Information Section -->
      <mat-step label="Personal Information" [hasError]="stepHasError('personal')" errorMessage="Required fields missing">
      <div class="grid gap-4 sm:grid-cols-2 lg:grid-cols-3 pt-4">
        <mat-form-field appearance="outline" class="w-full">
          <mat-label>First Name *</mat-label>
          <input matInput formControlName="firstName" placeholder="Enter first name">
          @if (employeeForm.controls.firstName.invalid && employeeForm.controls.firstName.touched) {
            <mat-error>First name is required.</mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-full">
          <mat-label>Surname *</mat-label>
          <input matInput formControlName="surname" placeholder="Enter surname">
          @if (employeeForm.controls.surname.invalid && employeeForm.controls.surname.touched) {
            <mat-error>Surname is required.</mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-full">
          <mat-label>Email Address *</mat-label>
          <input matInput type="email" formControlName="emailAddress" placeholder="Enter email">
          @if (hasError('emailAddress', 'required')) {
            <mat-error>Email address is required.</mat-error>
          }
          @if (hasError('emailAddress', 'email')) {
            <mat-error>Enter a valid email address.</mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-full">
          <mat-label>Contact Number *</mat-label>
          <input matInput formControlName="contactNumber" placeholder="Enter contact number">
          @if (hasError('contactNumber', 'required')) {
            <mat-error>Contact number is required.</mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-full">
          <mat-label>Employee Number *</mat-label>
          <input matInput formControlName="employeeNumber" placeholder="Enter employee number">
          @if (hasError('employeeNumber', 'required')) {
            <mat-error>Employee number is required.</mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-full">
          <mat-label>Employee Head Count</mat-label>
          <input matInput type="number" formControlName="employeeHeadCount" placeholder="Enter head count">
        </mat-form-field>
      </div>
      <!-- Demographic Information Section -->
      <div class="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        <mat-form-field appearance="outline" class="w-full">
          <mat-label>Title *</mat-label>
          <mat-select formControlName="titleId">
            <mat-option value="">Select title</mat-option>
            @for (item of titles(); track item.id) {
              <mat-option [value]="item.id">{{ item.name ?? item.code }}</mat-option>
            }
          </mat-select>
          @if (hasError('titleId', 'required')) {
            <mat-error>Title is required.</mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-full">
          <mat-label>Gender</mat-label>
          <mat-select formControlName="genderId">
            <mat-option value="">Select gender</mat-option>
            @for (item of genders(); track item.id) {
              <mat-option [value]="item.id">{{ item.name ?? item.code }}</mat-option>
            }
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-full">
          <mat-label>Race</mat-label>
          <mat-select formControlName="raceId">
            <mat-option value="">Select race</mat-option>
            @for (item of races(); track item.id) {
              <mat-option [value]="item.id">{{ item.name ?? item.code }}</mat-option>
            }
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-full">
          <mat-label>Marital Status</mat-label>
          <mat-select formControlName="maritalStatusId">
            <mat-option value="">Select marital status</mat-option>
            @for (item of maritalStatuses(); track item.id) {
              <mat-option [value]="item.id">{{ item.name ?? item.code }}</mat-option>
            }
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-full">
          <mat-label>Medical Aid</mat-label>
          <mat-select formControlName="medicalAidId">
            <mat-option value="">Select medical aid</mat-option>
            @for (item of medicalAids(); track item.id) {
              <mat-option [value]="item.id">{{ item.name ?? item.code }}</mat-option>
            }
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-full">
          <mat-label>Date of Birth *</mat-label>
          <input matInput [matDatepicker]="dateOfBirthPicker" formControlName="dateOfBirth">
          <mat-datepicker-toggle matIconSuffix [for]="dateOfBirthPicker"></mat-datepicker-toggle>
          <mat-datepicker #dateOfBirthPicker></mat-datepicker>
          @if (hasError('dateOfBirth', 'required')) {
            <mat-error>Date of birth is required.</mat-error>
          }
        </mat-form-field>
      </div>
      <!-- Location & Employment Section -->
      <div class="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        <mat-form-field appearance="outline" class="w-full">
          <mat-label>Country</mat-label>
          <mat-select formControlName="countryId">
            <mat-option value="">Select country</mat-option>
            @for (item of countries(); track item.id) {
              <mat-option [value]="item.id">{{ item.name ?? item.code }}</mat-option>
            }
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-full">
          <mat-label>Province *</mat-label>
          <mat-select formControlName="provinceId">
            <mat-option value="">Select province</mat-option>
            @for (item of provinces(); track item.id) {
              <mat-option [value]="item.id">{{ item.name ?? item.code }}</mat-option>
            }
          </mat-select>
          @if (hasError('provinceId', 'required')) {
            <mat-error>Province is required.</mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-full">
          <mat-label>Location</mat-label>
          <input matInput formControlName="location" placeholder="Enter location">
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-full">
          <mat-label>Employment Type *</mat-label>
          <mat-select formControlName="employmentTypeId">
            <mat-option value="">Select employment type</mat-option>
            @for (item of employmentTypes(); track item.id) {
              <mat-option [value]="item.id">{{ item.name ?? item.code }}</mat-option>
            }
          </mat-select>
          @if (hasError('employmentTypeId', 'required')) {
            <mat-error>Employment type is required.</mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-full">
          <mat-label>Date of Employment *</mat-label>
          <input matInput [matDatepicker]="dateOfEmploymentPicker" formControlName="dateOfEmployment">
          <mat-datepicker-toggle matIconSuffix [for]="dateOfEmploymentPicker"></mat-datepicker-toggle>
          <mat-datepicker #dateOfEmploymentPicker></mat-datepicker>
          @if (hasError('dateOfEmployment', 'required')) {
            <mat-error>Date of employment is required.</mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-full">
          <mat-label>Product Type *</mat-label>
          <mat-select formControlName="groupProductId">
            <mat-option value="">Select group product</mat-option>
            @for (item of groupProducts(); track item.id) {
              <mat-option [value]="item.id">{{ item.name ?? item.code }}</mat-option>
            }
          </mat-select>
          @if (hasError('groupProductId', 'required')) {
            <mat-error>Product type is required.</mat-error>
          }
        </mat-form-field>
      </div>
            <!-- Identification Section -->
      <div class="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        <mat-form-field appearance="outline" class="w-full">
          <mat-label>ID Number *</mat-label>
          <input matInput formControlName="idNumber" placeholder="Enter ID number">
          @if (hasError('idNumber', 'required')) {
            <mat-error>ID number is required.</mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-full">
          <mat-label>National ID Number</mat-label>
          <input matInput formControlName="nationalIdNumber" placeholder="Enter national ID number">
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-full">
          <mat-label>Passport Number</mat-label>
          <input matInput formControlName="passportNumber" placeholder="Enter passport number">
        </mat-form-field>
      </div>
      </mat-step>
      </mat-stepper>
        <!-- Submit Button -->
      <div class="grid grid-flow-col auto-cols-max gap-2 justify-end">
      @if (!readOnly()) {
        <div>
          <button mat-stroked-button type="button" (click)="reset()" [disabled]="busy()">
            Clear
          </button>
          </div>
          <div>
          <button mat-flat-button color="primary" type="submit" [disabled]="busy()">
            @if (busy()) {
              <span class="inline-flex items-center gap-2">
                <mat-spinner diameter="18" />
                Saving...
              </span>
            } @else {
              {{ submitLabel() }}
            }
          </button>
        </div>
      }
      <ng-content/>
      </div>
    </form>
  </mat-card-content>
</mat-card>
